import {UserProfileAttribute} from "../types.ts";

import {
    useDeleteUserProfileAttributeMutation,
    useUpdateUserProfileAttributeMutation,
    useUserProfileAttributeQuery,
} from "./useUserProfileAttributesQuery.ts";

// FNP-949: the single attribute comes from React Query. Return shape unchanged
// so the profile forms consuming this hook did not change.
//
// Note updateRecord/deleteRecord take their own id argument (rather than
// closing over the hook's) - that is the original contract and callers rely
// on it.
export const useUserProfileAttribute = (id?: string) => {

    const {
        data: record,
        isLoading,
        refetch
    } = useUserProfileAttributeQuery(id);

    const updateMutation = useUpdateUserProfileAttributeMutation();
    const deleteMutation = useDeleteUserProfileAttributeMutation();

    const fetchRecord = async () => {
        if (typeof id === 'undefined') {
            throw new Error('No id provided')
        }
        refetch()
    };

    const updateRecord = async (id: string, record: UserProfileAttribute) => {
        if (typeof id === 'undefined') {
            throw new Error('No id provided')
        }
        updateMutation.mutate({
            id,
            record
        })
    }

    const deleteRecord = async (id: string) => {
        if (typeof id === 'undefined') {
            throw new Error('No id provided')
        }
        deleteMutation.mutate(id)
    }

    return {
        record,
        loading: isLoading,
        fetchRecord,
        updateRecord,
        deleteRecord
    }
}
